import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLoginMutation } from "state/api";
import Loader from "components/Loader";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Login = () => {
  const [login, { loading }] = useLoginMutation();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [error, setError] = React.useState(null);
  const navigate = useNavigate();
  const { userToken } = useSelector((state) => state.auth);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
    }),

    onSubmit: (values) => {
      const { email, password } = values;
      setIsSubmitting(true);
      login({ email, password })
        .unwrap()
        .then((res) => {
          localStorage.setItem("userToken", res.token);
          setIsSubmitting(false);
          navigate("/");
        })
        .catch((err) => {
          setError(err.data.message);
        })
        .finally(() => {
          setIsSubmitting(false);
        });

      //

      formik.resetForm();
    },
  });

  React.useEffect(() => {
    if (userToken) {
      navigate("/");
    }
  }, [userToken, navigate]);

  // show the loader initially and when the submit button is clicked
  if (loading || isSubmitting) {
    return <Loader />;
  }
  return (
    <div className="h-auto">
      <section>
        <div className="flex flex-col items-center justify-center px-6 py-4 mx-auto h-screen md:h-fit lg:py-0">
          <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
                Sign in to your account
              </h1>
              <form
                className="space-y-4 md:space-y-6"
                onSubmit={formik.handleSubmit}
              >
                <div>
                  <label
                    htmlFor="email"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Your email
                  </label>

                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder=""
                    className="bg-gray-50 border border-gray-300 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 "
                    required
                    value={formik.values.email}
                    onChange={formik.handleChange}
                  />
                  {/* error message */}
                  {formik.errors.email && formik.touched.email && (
                    <p className="text-red-500 text-xs italic">
                      {formik.errors.email}
                    </p>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="password"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Password
                  </label>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    placeholder=""
                    className="bg-gray-50 border border-gray-300 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 "
                    required
                    value={formik.values.password}
                    onChange={formik.handleChange}
                  />
                  {/* error message */}
                  {formik.errors.password && formik.touched.password && (
                    <p className="text-red-500 text-xs italic">
                      {formik.errors.password}
                    </p>
                  )}
                </div>
                {/* error message */}
                {error ? (
                  <p className="text-red-500 text-xs italic">{error}</p>
                ) : null}

                {/* <div className="flex items-center justify-between">
                  <a
                    href="/forget-password"
                    className="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500"
                  >
                    Forgot password?
                  </a>
                </div> */}
                <button
                  type="submit"
                  className="bg-black text-white rounded-lg px-3 py-2.5 hover:bg-gray-900 w-full border-none cursor-pointer hover:shadow-lg"
                >
                  Sign in
                </button>

                {/* <hr className="my-8" /> */}

                {/* <p className="mt-4 text-center">
                  <span className="text-sm font-medium text-gray-900">
                    Don't have an account?
                  </span>
                  <a
                    href="/register"
                    className="text-sm font-medium text-primary-600 hover:underline"
                  >
                    Sign up
                  </a>
                </p> */}
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Login;
